<template>
  <div class="full-height">
    <appointment-details-header-mobile
      :appointment="appointment"
      @close="$emit('close')"></appointment-details-header-mobile>
    <status-timeline-mobile :appointment="appointment"></status-timeline-mobile>
    <v-divider class="my-4"></v-divider>
    <appointment-details-mobile
      class="px-6"
      :appointment="appointment"
      :appointment-warehouse="appointmentWarehouse"></appointment-details-mobile>
  </div>
</template>

<script>
export default {
  name: 'AppointmentDetailsPageMobile',
  props: {
    appointment: {
      type: Object,
      required: true
    },
    appointmentWarehouse: {
      type: Object,
      required: true
    }
  },
  methods: {}
};
</script>
